export function userIsAuthorizedForBuzz(userGroups) {
  return userGroups.findIndex(p => p === 'Buzz') != -1;
}